"use strict";

export const pdpLoadDataLogger = ({
  ctx,
  asPath,
  gqlProductParams,
  productDetailPageData,
  code,
  message,
  error,
  pidLocale,
  responseStatusCode,
  responseRedirectUrl,
  loggingLevel = "log",
}) => {
  if (typeof window === "undefined") {
    try {
      console[loggingLevel](
        JSON.stringify({
          code: code,
          message,
          graphqlError: error?.message,
          ssrRequest: {
            reqHostname: ctx?.req?.headers?.host,
            // dont log the guest's cookies for security purposes
            reqHeaders:
              typeof ctx?.req?.headers === "object"
                ? Object.keys(ctx?.req?.headers)
                    .filter((key) => key !== "cookie")
                    .reduce((obj, key) => {
                      obj[key] = ctx?.req?.headers[key];
                      return obj;
                    }, {})
                : {},
            correlationId:
              ctx?.req?.headers?.["x-lll-ecom-correlation-id"] || "NOT_FOUND",
            uriPath: asPath,
            graphql: {
              gqlProductParams,
              gqlTruncatedResponse: {
                allLocalePids: productDetailPageData?.allLocalePids,
              },
            },
            pid: gqlProductParams?.productId,
            pidLocale: pidLocale,
            nextLocale: ctx?.nextLocale,
          },
          ssrResponse: {
            statusCode: responseStatusCode,
            redirectUrl: responseRedirectUrl,
          },
        })
      );
    } catch (e) {
      // All logging events must be handled, it should not down the site
      console.error({
        code: "PDP_LOGGING_ERROR",
        message:
          "A PDP logging event occured, but there was an error logging it",
        error: e,
      });
    }
  }
};
